function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RichText from "@common/components/BoxDetailsTab/RichText";
import { isEmpty } from "lodash";
import React from "react";
import { connect } from "react-redux";
var TableSlice = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var items = props.items;
    return /*#__PURE__*/ _jsx("table", {
        className: "specs-table",
        children: /*#__PURE__*/ _jsx("tbody", {
            children: items.map(function(item, index) {
                var _item_title, _item_text;
                return /*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx("td", {
                            className: "gray",
                            children: /*#__PURE__*/ _jsx(RichText, _object_spread({}, item === null || item === void 0 ? void 0 : (_item_title = item.title) === null || _item_title === void 0 ? void 0 : _item_title[0]))
                        }),
                        /*#__PURE__*/ _jsx("td", {
                            className: "black",
                            children: /*#__PURE__*/ _jsx(RichText, _object_spread({}, item === null || item === void 0 ? void 0 : (_item_text = item.text) === null || _item_text === void 0 ? void 0 : _item_text[0]))
                        })
                    ]
                }, index);
            })
        })
    });
};
var TextSlice = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _items_;
    var items = props.items;
    var textArr = items === null || items === void 0 ? void 0 : (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.text;
    return /*#__PURE__*/ _jsx("div", {
        children: textArr.map(function(text, index) {
            if (text.type === "paragraph") {
                return /*#__PURE__*/ _jsx(RichText, _object_spread({}, text), index);
            } else if (text.type === "image") {
                return /*#__PURE__*/ _jsx("img", {
                    className: "inline-image",
                    src: text.url,
                    alt: text.alt
                }, index);
            }
        })
    });
};
export var BoxDetailsTab = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _props_primary, _props_primary1, _props_primary_tab_title_, _props_primary_tab_title, _props_primary2;
    var slice_type = props.slice_type;
    var renderSlice = function() {
        switch(slice_type){
            case "list":
                return /*#__PURE__*/ _jsx(TableSlice, {
                    items: props.items
                });
            case "text":
                return /*#__PURE__*/ _jsx(TextSlice, {
                    items: props.items
                });
            default:
                return null;
        }
    };
    var imageProps = (_props_primary = props.primary) === null || _props_primary === void 0 ? void 0 : _props_primary.image;
    var imagePosition = (_props_primary1 = props.primary) === null || _props_primary1 === void 0 ? void 0 : _props_primary1.image_position;
    var contentArr = [
        /*#__PURE__*/ _jsxs("div", {
            className: "contents-wrapper",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "tv-box-title",
                    children: (_props_primary2 = props.primary) === null || _props_primary2 === void 0 ? void 0 : (_props_primary_tab_title = _props_primary2.tab_title) === null || _props_primary_tab_title === void 0 ? void 0 : (_props_primary_tab_title_ = _props_primary_tab_title[0]) === null || _props_primary_tab_title_ === void 0 ? void 0 : _props_primary_tab_title_.text
                }),
                renderSlice()
            ]
        })
    ];
    if (!isEmpty(imageProps)) {
        contentArr.push(/*#__PURE__*/ _jsx("div", {
            className: "box-image-wrapper",
            children: /*#__PURE__*/ _jsx("img", {
                className: "box-image",
                src: imageProps === null || imageProps === void 0 ? void 0 : imageProps.url,
                alt: imageProps === null || imageProps === void 0 ? void 0 : imageProps.alt
            })
        }));
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "".concat([
            "Top",
            "Bottom"
        ].includes(imagePosition) ? "column" : "row", " box-details-wrapper"),
        children: [
            "Right",
            "Bottom"
        ].includes(imagePosition) ? contentArr : contentArr.reverse()
    });
};
var mapStateToProps = function(state) {
    return {};
};
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(BoxDetailsTab);
